function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["label", "value", "defaultValue", "className", "inputRef"],
  _excluded2 = ["label", "className"],
  _excluded3 = ["defaultValue", "value"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import { Label } from 'reactstrap';
import Flatpickr from 'react-flatpickr';
import "flatpickr/dist/themes/material_green.css";
var CustomDateInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var label = _ref.label,
    value = _ref.value,
    defaultValue = _ref.defaultValue,
    className = _ref.className,
    inputRef = _ref.inputRef,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, null, label, otherProps.required && /*#__PURE__*/React.createElement("span", {
    className: "required"
  }, "*")), /*#__PURE__*/React.createElement("input", Object.assign({
    type: "date",
    className: "".concat(className, " form-control ").concat(otherProps.error ? 'error' : ''),
    defaultValue: defaultValue,
    ref: inputRef
  }, otherProps)));
});
var DateInput = function DateInput(_ref2) {
  var label = _ref2.label,
    className = _ref2.className,
    otherProps = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(Flatpickr, {
    onChange: otherProps === null || otherProps === void 0 ? void 0 : otherProps.onChange,
    value: otherProps === null || otherProps === void 0 ? void 0 : otherProps.value,
    options: _objectSpread({
      enableTime: true,
      enableSeconds: true,
      defaultHour: 23,
      defaultMinute: 59,
      minTime: '00:00',
      maxTime: '23:59',
      minDate: 'today',
      time_24hr: true,
      allowInput: true,
      altInput: true,
      altFormat: "F j, Y H:i"
    }, otherProps),
    render: function render(_ref3, ref) {
      var defaultValue = _ref3.defaultValue,
        value = _ref3.value,
        props = _objectWithoutProperties(_ref3, _excluded3);
      return /*#__PURE__*/React.createElement(CustomDateInput, Object.assign({
        value: value,
        label: label,
        className: className,
        defaultValue: value,
        inputRef: ref
      }, props));
    }
  });
};
export default DateInput;